import React, { useEffect, useState } from "react";
import axios from "axios";
import backendUrl from "../BackendUrl";
import "../styles/Parts.css";

const Parts = () => {
  const [parts, setParts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPart, setSelectedPart] = useState(null);

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/parts/get-part`);
        const data = Array.isArray(response.data) ? response.data : [];
        setParts(data.filter((p) => p.ready));
      } catch (error) {
        console.error("Error fetching parts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchParts();
  }, []);

  // Open modal with part details
  const handleViewDetails = (part) => {
    setSelectedPart(part);
  };

  // Close the details modal
  const handleCloseDetails = () => {
    setSelectedPart(null);
  };

  return (
    <div className="parts-container">
      <h1 className="parts-title">Available Parts</h1>
      {loading ? (
        <p className="loading-text">Loading parts...</p>
      ) : parts.length === 0 ? (
        <p className="no-parts-text">No parts available.</p>
      ) : (
        <div className="parts-wrapper">
          {parts.map((part) => (
            <div key={part._id} className="part-card">
              {part.partImg && (
                <img src={part.partImg} alt={part.part} className="part-image" />
              )}
              <h2 className="part-name">{part.part}</h2>
              <p className="part-description">{part.description}</p>
              {part.price && <p className="part-price">Price: ${part.price}</p>}
              <div className="detail-container">
                <button onClick={() => handleViewDetails(part)} className="detail-button">
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedPart && (
        <div className="part-detail-overlay">
          <div className="part-detail-modal">
            <button className="close-button" onClick={handleCloseDetails}>
              X
            </button>
            {selectedPart.partImg && (
              <img
                src={selectedPart.partImg}
                alt={selectedPart.part}
                className="detail-image"
              />
            )}
            <h2>{selectedPart.part}</h2>
            <p>{selectedPart.description}</p>
            {selectedPart.dependencies && selectedPart.dependencies.length > 0 && (
              <p>
                <strong>Dependencies:</strong> {selectedPart.dependencies.join(", ")}
              </p>
            )}
            {selectedPart.vehicles && selectedPart.vehicles.length > 0 && (
              <p>
                <strong>Vehicles:</strong> {selectedPart.vehicles.join(", ")}
              </p>
            )}
            {selectedPart.price && (
              <p>
                <strong>Price:</strong> ${selectedPart.price}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Parts;